exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-common-overlay{background-color:hsla(0,0%,100%,.95);position:absolute;top:0;left:0;justify-content:center;height:100%;width:100%}", ""]);

// exports
